import React from 'react';
import { alignSingleBarLeft, hideBarPadLabel, CHART_TITLE_STYLE } from "../HelperFunction/helperFunction";
import Chart from 'react-apexcharts';
import { useOutletContext } from 'react-router-dom';
import { niceAxisMax } from '../HelperFunction/helperFunction';

function SingleBarChart1({ fulldataset, type, isValue, range, axisMax }) {
  const { theme } = useOutletContext();
  const isDark = theme !== 'light';
  const formatedplot3 = fulldataset?.plot3?.map((item) => {
    if (item.type === "Core") {
      return {
        ...item,
        volume: item.total_core,
        value: item.total_core_sales
      }
    }
    else if (item.type === "Incremental" || item.type === "Increment") {
      return {
        ...item,
        volume: item.total_incremental,
        value: item.total_incremental_sales
      }
    }
    else {
      return {
        ...item,
        volume: item.total_media,
        value: item.total_media_sales
      }
    }

  })
  const isStacked = formatedplot3?.some(item => item?.frequency);


  let categories, series;

  if (isStacked) {
    // Extract unique frequencys and media variable types
    let uniqueFrequency = Array.from(new Set(formatedplot3.map(item => item?.frequency)));
    let uniqueMediaTypes = Array.from(new Set(formatedplot3.map(item => item?.type)));

    // Group data by media variable type (stacked chart case)
    series = uniqueMediaTypes.map(mediaType => {
      return {
        name: mediaType,
        data: uniqueFrequency.map(frequency => {
          let dataPoint = formatedplot3.find(item => item.type === mediaType && item?.frequency === frequency);
          return dataPoint ? (isValue ? Number(dataPoint.value / 100000).toFixed(2) : Number(dataPoint.volume / 1000).toFixed(0)) : 0;
        })
      };
    });
    categories = uniqueFrequency;
  } else {
    // Extract unique media variable types (non-stacked case)
    let uniqueMediaTypes = Array.from(new Set(formatedplot3.map(item => item?.type)));

    // Group data normally
    series = [{
      name: "Contribution",
      data: uniqueMediaTypes.map(mediaType => {
        let dataPoint = formatedplot3.find(item => item.type === mediaType);
        return dataPoint ? (isValue ? Number(dataPoint.value / 100000).toFixed(2) : Number(dataPoint.volume / 1000).toFixed(0)) : 0;
      })
    }];
    categories = uniqueMediaTypes;
  }

  const stackPeak = (() => {
    const rows = series || [];
    if (!isStacked) {
      const nums = rows.flatMap((item) => (item.data || []).map(Number)).filter(Number.isFinite);
      return nums.length ? Math.max(0, ...nums) : 0;
    }
    const len = Math.max(0, ...rows.map((item) => item.data?.length || 0));
    let peak = 0;
    for (let i = 0; i < len; i += 1) {
      const sum = rows.reduce((acc, item) => acc + (Number(item.data?.[i]) || 0), 0);
      if (sum > peak) peak = sum;
    }
    return peak;
  })();
  const ownMax = niceAxisMax(stackPeak);
  const sharedMax = Number(axisMax);
  const yMax = Number.isFinite(sharedMax) && sharedMax > 0 ? sharedMax : ownMax;
  const yAxisLabel = `Contribution ${isValue ? "Value (Lacs)" : "Volume (Kg Tonnes)"}`;

  ({ categories, series } = alignSingleBarLeft(categories, series));
  const barColumnWidth = `${Math.min(70, Math.max(categories?.length || 1, 1) * 11)}%`;

  const options = {
    chart: {
      id: `Download-Contribution Chart `,
      type: 'bar',
      stacked: isStacked,
      toolbar: {
        show: true,
      },
      background: 'transparent',
    },
    grid: {
      show: false
    },
    tooltip: {
      theme: isDark ? 'dark' : 'light',
    },
    title: {
      text: `Contribution ${isValue ? "Value" : "Volume"} (${type})`,
      align: 'center',
      style: CHART_TITLE_STYLE,
    },
    colors: ["#17A2B8", "#FF8C00", "#0D7C66"],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: barColumnWidth,
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: isStacked ? false : true,
      offsetY: -15,
      style: {
        fontFamily: "'JetBrains Mono', 'Inter', monospace",
        fontSize: '12px',
        fontWeight: 600,      },
      formatter: function (val) {
        return (val?.toLocaleString("en-IN"));
      },
    },
    xaxis: {
      categories: categories,
      title: {
        text: isStacked ? 'Frequency' : '',
        style: {
          fontWeight: 600,
          fontSize: "12px",        },
      },
      labels: {
        rotate: -35,
        rotateAlways: true,
        formatter: (val) => hideBarPadLabel(val),
        style: {
          fontWeight: 500,
          fontSize: "11px",        },
      },
    },
    yaxis: {
      axisBorder: {
        show: true
      },
      min: 0,
      max: yMax,
      forceNiceScale: false,
      labels: {
        style: {
          fontWeight: 500,
          fontSize: "11px",        },
        formatter: function (val) {
          const num = Number(val);
          if (!Number.isFinite(num)) return "";
          return yMax < 10 ? num.toFixed(1) : num.toFixed(0);
        },
      },
    },
    legend: {
      show: isStacked,
      position: 'bottom',
      horizontalAlign: 'center',
      fontSize: "12px",    },
    annotations: {
      yaxis: [{
        y: 0, // Place the annotation at zero
        borderColor: '#6C757D',
        label: {
          text: '',
          style: {
            color: '#6C757D',
            background: '#1A252F'
          }
        }
      }]
    }
  };

  return (
    <>
      <div className="rr-chart-period">
        <small>Time Period: {range}</small>
      </div>
      <div className="rr-chart-yaxis">
        <span className="rr-chart-yaxis-label">{yAxisLabel}</span>
        <div className="rr-chart-yaxis-body">
          <Chart className="rr-apex rr-apex-bar"
            align="center"
            options={options}
            series={series}
            type="bar"
            height={320}
            width={'100%'}
          />
        </div>
      </div>
    </>
  );
}

export default SingleBarChart1;
